import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { includes, isEmpty, last, toLower } from 'lodash';
import invalidMsg from './lang';
let default_1 = class default_1 extends Vue {
    imageValid;
    base64Image;
    types;
    maxSize;
    bgPlaceholder;
    size;
    loading = false;
    get listTypeTip() {
        return this.types.join('、');
    }
    get accept() {
        return this.types.map((item) => `image/${item}`).join(', ');
    }
    convertBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (e) => reject(e);
        }).catch((e) => console.log('error', e));
    }
    async onImgChoosen(data) {
        const { raw, name, size } = data;
        const base64Image = (await this.convertBase64(raw));
        if (await this.isFormatValid(name, size, base64Image)) {
            await this.converImg(base64Image);
        }
        else {
            this.$elmessage.error(this.$t('formatError').toString());
        }
        return false;
    }
    async isFormatValid(name, size, base64Image) {
        const suffix = last(name.split('.'));
        const nameValid = includes(this.types, toLower(suffix));
        const maxSize = Number(this.maxSize) || 0;
        const sizeValid = maxSize <= 0 || size <= maxSize;
        return nameValid && sizeValid && this.checkMeasurement(base64Image);
    }
    async converImg(base64Image) {
        this.loading = true;
        try {
            this.$emit('update:imageValid', true);
            this.$emit('update:base64Image', base64Image);
        }
        catch (e) {
            this.$elmessage.error(this.$t('common.unknownError').toString());
            this.remove();
        }
        finally {
            this.loading = false;
        }
    }
    async checkMeasurement(resource) {
        if (isEmpty(this.size)) {
            return true;
        }
        try {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = (_) => {
                    const { height, width } = this.size || {};
                    resolve(img.height === height && img.width === width);
                };
                img.src = resource;
                setTimeout(() => {
                    resolve(false);
                }, 5000);
            });
        }
        catch {
            return false;
        }
    }
    remove() {
        this.$emit('update:base64Image', '');
        this.$emit('update:imageValid', false);
    }
    onDialogConfirm() {
        this.remove();
    }
    onDialogCancel() { }
};
__decorate([
    Prop()
], default_1.prototype, "imageValid", void 0);
__decorate([
    Prop()
], default_1.prototype, "base64Image", void 0);
__decorate([
    Prop()
], default_1.prototype, "types", void 0);
__decorate([
    Prop()
], default_1.prototype, "maxSize", void 0);
__decorate([
    Prop()
], default_1.prototype, "bgPlaceholder", void 0);
__decorate([
    Prop()
], default_1.prototype, "size", void 0);
default_1 = __decorate([
    Component({
        name: 'ImgChecker',
        components: {},
        i18n: {
            messages: {
                en: {
                    click: 'Click/Drag to Upload',
                    support: 'Support type: ',
                    formatError: 'Invalid image format /size',
                    maxSize: 'Max size: ',
                },
                zh: { click: '点击或拖拽上传', support: '支持类型：', formatError: '图片格式/大小无效', maxSize: '最大尺寸：' },
            },
            sharedMessages: invalidMsg,
        },
    })
], default_1);
export default default_1;
